<template>
  <div class="rb-ob-form rb-match-page rb-book-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.conflictTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ $t('intake.conflictBody') }}</p>
    </div>

    <ul class="rb-book-summary" :aria-label="$t('intake.conflictSummaryAria')">
      <li>
        <span class="rb-book-summary-k">{{ $t('intake.conflictChosenTime') }}</span>
        <span class="rb-book-summary-v">{{ summaryTime }}</span>
      </li>
      <li>
        <span class="rb-book-summary-k">{{ $t('intake.conflictStatusLabel') }}</span>
        <span class="rb-book-summary-v">{{ $t('intake.conflictStatus') }}</span>
      </li>
    </ul>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="pickOther">
        {{ $t('intake.conflictPickOther') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite"></p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {loadMatchSession} from '@/intake/sandboxMatchSession'
import {isMatchmakingV2ApiEnabled} from '@/intake/sandboxMatchApi'
import {loadIntake} from '@/intake/intakeState'
import {bookingSummary} from '@/intake/bookingSummary'

export default {
  name: 'MatchConflictStep',
  computed: {
    summaryTime() {
      const draft = loadIntake()
      return bookingSummary(draft, loadMatchSession(), this.$i18n.locale, isMatchmakingV2ApiEnabled())
    },
  },
  methods: {
    pickOther() {
      const draft = loadIntake()
      if (!draft.therapistId && isMatchmakingV2ApiEnabled()) {
        return this.$router.push({name: 'intakeMatching', params: {lang: this.$route.params.lang || 'fa'}})
      }
      this.$router.push({
        name: 'intakeSlots',
        params: {
          lang: this.$route.params.lang || 'fa',
          therapistId: draft.therapistId || 't1',
        },
      })
    },
  },
}
</script>
